import * as React from "react";
import {TextField} from "components/common/inputFunctions";
import {useEffect, useRef, useState} from "react";
import {Link} from "react-router-dom";
import {Fields} from "userform/utils";
import Otp from "userform/otp";
import {bindGapiObjectToButton, loadGoogleScript} from "login/gapiLogin";
import {clearUpdateEmailProps, sendUpdateEmailOtp, updateEmailFromHagrid} from "login/actions";
import {
    IUserInput,
    updateUserInputForEmailUpdation,
    defaultUserInput,
    validateUpdateEmailFields,
    defaultValidationStatus, getUpdateEmailRelatedMessages,
    shubhloansLogo,
} from "login/utils";
import {IValidation} from "StateInterface";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {googleClientId, googleLoginVersion, googleScript} from "config";
import classNames from "classnames";
import {setAuthentication} from "service";

interface IEmailUpdateResponse {status: string; msg: string};

interface IConnectProps {
    dispatch?: (action: any) => void;
    emailUpdateResponse: IEmailUpdateResponse;
    userFound: string;
    requestId: string;
}

function UpdateEmail(props: IConnectProps) {
    const [userInput, updateUserInput] = useState<IUserInput>(defaultUserInput);
    const [showGoogleButton, setShowGoogleButton] = useState(false);
    const userInputRef = useRef<IUserInput>(userInput);
    const [validationStatus, updateValidationStatus] = useState<IValidation>(defaultValidationStatus);
    function handleChange(fieldName: Fields, value: number | string) {
        updateUserInput(updateUserInputForEmailUpdation(userInput, fieldName, value));
        updateValidationStatus(defaultValidationStatus);
    }
    function renderGenerateOtp() {
        return(
            <div onClick={handleGenerateOtp}>
                <button className="btn btn-lg btn-block update-email-hero-btn">Generate OTP</button>
            </div>
        );
    }
    function renderGotoLogin() {
        return(
            <Link to={"/"} style={{textDecoration: "none"}}>
                <button className="btn btn-lg btn-block update-email-hero-btn">Go To Login</button>
            </Link>
        );
    }
    function renderOtpComponent() {
        return (<Otp
            newUI={true}
            otpDigits={6}
            timer={80}
            onSubmit={handleUpdateEmail}
            onSend={handleGenerateOtp}
            requestedOtp={true}
            error=""
        />);
    }
    function handleGenerateOtp() {
        const {mobile, pan} = userInput;
        const validation = validateUpdateEmailFields(mobile, pan);
        if (validation.status) {
            props.dispatch(sendUpdateEmailOtp(mobile, pan));
            props.dispatch(clearUpdateEmailProps());
        }
        updateValidationStatus(validation);
    }
    function handleUpdateEmail(otp: number) {
        const updatedUserInput = updateUserInputForEmailUpdation(userInput, Fields.OTP, otp);
        updateUserInput(updatedUserInput);
        userInputRef.current = updatedUserInput;
        if (googleLoginVersion === "V2") {
            setShowGoogleButton(true);
        } else {
            const loginButton = document.getElementById("update-email-gmail-login");
            loginButton.click();
        }
    }
    function renderMessage(userFound: string, emailUpdateResponse: IEmailUpdateResponse) {
        const msgDetails = getUpdateEmailRelatedMessages(userFound, emailUpdateResponse);
        if (msgDetails.status === null) return undefined;
        return (
            <div className={`${msgDetails.status === "SUCCESS" ? "text-success" : "text-danger"} update-email-response text-center mt-3`}>
                {msgDetails.msg}
            </div>
        );
    }
    function renderButton(userFound: string, emailUpdateResponse: IEmailUpdateResponse) {
        if (userFound !== "SUCCESS" && emailUpdateResponse.status !== "SUCCESS") {
            return renderGenerateOtp();
        }
        if (userFound === "SUCCESS" && emailUpdateResponse.status === null) {
            return renderOtpComponent();
        }
        if (emailUpdateResponse.status === "SUCCESS") {
            return renderGotoLogin();
        }
        return undefined;
    }
    useEffect(() => {
        window.scrollTo(0, 0);
        if (googleLoginVersion === "V2") {
            loadGoogleScript(googleScript, () => {
                (window as any).google.accounts.id.initialize({
                    client_id: googleClientId,
                    itp_support: true,
                    callback: (cred: { credential: string; select_by: string }) => {
                        setShowGoogleButton(false);
                        props.dispatch(clearUpdateEmailProps());
                        setAuthentication(cred.credential)
                        props.dispatch(
                            updateEmailFromHagrid(
                                userInputRef.current.otp,
                                props.requestId,
                            ),
                        );
                    },
                });

                (window as any).google.accounts.id.renderButton(
                    document.getElementById("update-email-gmail-login"),
                    {size: "large", theme: "filled_blue", width: 300},
                );
            });
        } else {
            const btnNames = ["update-email-gmail-login"];
            bindGapiObjectToButton(btnNames, (googleUser) => {
                if (googleUser.getAuthResponse().id_token) {
                    props.dispatch(clearUpdateEmailProps());
                    setAuthentication(googleUser.getAuthResponse().id_token)
                    props.dispatch(updateEmailFromHagrid(
                        userInputRef.current.otp,
                        props.requestId,
                    ));
                }
            });
        }
        return () => props.dispatch(clearUpdateEmailProps());

    }, [props.requestId]);
    return (
        <div className="update-email-container container-fluid">
            <div className="row justify-content-center">
                <div className="card col-11 update-email-card">
                    <div className="card-body">
                        <img className="update-email-logo text-center" src={shubhloansLogo} alt="Logo" />
                        <p className="title-text">Connect your email to the MyShubhLife account</p>
                        <TextField label="Mobile Number" value={userInput.mobile} fieldName={Fields.MOBILE}
                                   onChange={handleChange} type="text"
                                   error={validationStatus.type === Fields.MOBILE ? validationStatus.msg : ""}
                        />
                        <TextField label="PAN Number" value={userInput.pan} fieldName={Fields.PAN_NUMBER}
                                   onChange={handleChange} type="text"
                                   error={validationStatus.type === Fields.PAN_NUMBER ? validationStatus.msg : ""}
                        />
                        {renderMessage(props.userFound, props.emailUpdateResponse)}
                        {!showGoogleButton && renderButton(props.userFound, props.emailUpdateResponse)}
                        <div style={{width: 300, paddingTop: 5, margin: "auto"}}>
                            <div
                                id="update-email-gmail-login"
                                className={classNames({"d-none": !showGoogleButton})}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
        emailUpdateResponse: state.login.emailUpdateResponse,
        userFound: state.login.userFound,
        requestId: state.login.requestId,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(UpdateEmail);
